<template>
    <main class="fw-v2" role="main">
        <portal to="ariane">
            <div class="tbv2-page-title">{{ $t('wizard.newForm') }}</div>
        </portal>

        <custom-wizard :form-id="formId" :is-backoffice="true" />
    </main>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import CustomWizard from '@/components/Wizard/CustomWizard.vue'
import { unhashId } from '@/helpers/hashId'

export default {
    name: 'FormWizard',
    components: { CustomWizard },
    computed: {
        formId() {
            const raw = this.$route.params.id || this.$route.params.formId
            return unhashId(raw) || raw
        }
    }
}
</script>

<style scoped>
.fw-v2 {
    width: 100%;
    font-family: var(--v2-font-sans);
    color: var(--v2-text-2);
}

.tbv2-page-title {
    font-size: 0.95rem;
    font-weight: var(--v2-font-weight-semibold);
    color: var(--v2-text-1);
    letter-spacing: -0.005em;
}
</style>
